import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader } from "../components/layout/AppLayout";
import { MapPin } from "@phosphor-icons/react";

export default function FieldTechs() {
  const [techs, setTechs] = useState([]);
  useEffect(() => { (async () => setTechs((await api.get("/field-techs")).data))(); }, []);

  return (
    <div>
      <PageHeader
        overline="Physical Layer · Read-only view"
        title="Field Technicians"
        subtitle="Remote hands & feet across regions. Data flows in from the Personnel tab."
      />

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {techs.map((t) => (
          <div key={t.id} data-testid={`tech-card-${t.id}`} className="tactical-card border border-slate-200 bg-white rounded-lg p-5">
            <div className="flex items-start justify-between">
              <div>
                <div className="font-medium text-[#0F1E38]">{t.name}</div>
                <div className="text-xs font-mono text-slate-500 mt-0.5 flex items-center gap-1"><MapPin size={11}/> {t.region}</div>
              </div>
            </div>

            <div className="mt-4 flex flex-wrap gap-1">
              {t.skills?.map((s) => <span key={s} className="text-[10px] font-mono px-1.5 py-0.5 rounded bg-violet-500/10 text-violet-300 border border-violet-500/30">{s}</span>)}
            </div>

            <div className="mt-4 flex items-center justify-between text-xs">
              <span className="font-mono text-[#0F1E38]">${t.hourly_rate}/hr</span>
              <span className={`text-[10px] font-mono uppercase px-2 py-0.5 rounded border ${t.status === "available" ? "text-emerald-400 border-emerald-500/40 bg-emerald-500/10" : "text-amber-400 border-amber-500/40 bg-amber-500/10"}`}>{t.status}</span>
            </div>
            <div className="mt-3">
              <div className="text-[10px] overline mb-1">Utilization {t.utilization}%</div>
              <div className="w-full h-1.5 bg-slate-200 rounded"><div className="h-full bg-violet-400" style={{ width: `${t.utilization}%`, transition:"width 0.4s ease" }} /></div>
            </div>
            {t.abn_number && <div className="mt-3 text-[10px] font-mono text-amber-400">Subcontractor · {t.abn_number}</div>}
          </div>
        ))}
      </div>
      {techs.length === 0 && <div className="grid-bg py-20 text-center text-sm text-slate-500 rounded border border-slate-200">No field technicians yet.</div>}
    </div>
  );
}
